// @flow
import { handleResponseOld, makeGet } from './helpers';
import transform from './wonLostCatalogsTransform';

export type FetchWonItemsParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    page?: number,
    pageSize?: number,
};

export const fetchWonItems = ({ authToken, bidderId, deployment, page = 1, pageSize = 1250 }: FetchWonItemsParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/wonitems`,
            queryParams: { client_version: '5.0', page, pagesize: pageSize },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response, transform }));
    });
};
